import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import AuthService from 'api/services/AuthService';
import ErrorPage403 from './ErrorPage403';
import PropTypes from 'prop-types';

/**
 * Route guard that checks session validity and authorization.
 *
 * New usage (permission-based):
 *   <PrivateRoute path="/campaigns" permission="campaigns:view" component={Campaigns} />
 *
 * Legacy usage (role-based, kept for backward compat):
 *   <PrivateRoute path="/analytics" roles={[ROLES.GROUP_A]} component={Analytics} />
 */
export const PrivateRoute = ({ component: Component, permission, roles, ...rest }) => (
    <Route {...rest} render={props => {

        if (!AuthService.isValidSession()) {
            return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        }

        const isAuthorised = permission
            ? AuthService.hasPermission(permission)
            : AuthService.isUserAuthorized(roles);

        if (!isAuthorised) {
            return <ErrorPage403 />
        }

        return <Component {...props} />
    }} />
)

PrivateRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  permission: PropTypes.string,
  roles: PropTypes.array,
  location: PropTypes.object,
};
